import * as types from './fileActionTypes';

export const uploadFile = (file, seasonId, formName, fieldName, fileType) => ({
  type: types.UPLOAD_FILE_REQUEST,
  file,
  seasonId,
  formName,
  fieldName,
  fileType
});



// WEBPACK FOOTER //
// ./src/store/file/fileActions.js